import { useMemo } from 'react';
import { PathsManifest } from '@zg-rentals/paths-manifest';
import type { Brand } from '../types/brand';

export default (baseUrl: string, brand: Brand) => {
  return useMemo(() => {
    const pathsManifest = new PathsManifest(baseUrl, brand);
    return {
      paths: pathsManifest.getAllPaths(),
    };
  }, [baseUrl, brand]);
};
